import type { FilterItemConfig } from '../types';

/**
 * Static config invariants enforced at mount AND on every `items` reconciliation.
 *
 * Plan Section "pinned × clearable":
 *   1. `clearable: false` requires `pinned: true`.
 *   2. `clearable: false` requires a default source (`defaultValue` or `getDefaultValue`).
 *
 * Uniform across all variants — there is no per-variant forcing. A SEGMENT_TOGGLE
 * with no explicit `pinned`/`clearable` is treated the same as any other field.
 * Consumers wanting the always-visible primary-toggle pattern declare it at the
 * call site (`pinned: true, clearable: false, defaultValue: ...`).
 */
export function validateItems(items: FilterItemConfig[]): void {
  const seen = new Set<string>();
  for (const item of items) {
    if (seen.has(item.name)) {
      const message = `[FilterBar] Duplicate field name "${item.name}". Each FilterItemConfig.name must be unique.`;

      console.error(message);
      throw new Error(message);
    }
    seen.add(item.name);

    if (item.clearable === false) {
      if (item.pinned !== true) {
        const message = `[FilterBar] Field "${item.name}" has \`clearable: false\` but \`pinned\` is not true. \`clearable: false\` requires \`pinned: true\`.`;

        console.error(message);
        throw new Error(message);
      }
      const hasStaticDefault = item.defaultValue !== undefined;
      const hasDynamicDefault = typeof item.getDefaultValue === 'function';
      if (!hasStaticDefault && !hasDynamicDefault) {
        const message = `[FilterBar] Field "${item.name}" has \`clearable: false\` but no \`defaultValue\` or \`getDefaultValue\`. \`clearable: false\` requires a default source.`;

        console.error(message);
        throw new Error(message);
      }
    }
  }
}
